import { Wordmark } from "@/components/Brand";
import InstallButton from "@/components/InstallButton";
import { Separator } from "@/components/ui/separator";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-card" data-testid="site-footer">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row">
          <div className="max-w-sm">
            <Wordmark withTagline />
            <p className="mt-4 text-sm leading-6 text-muted-foreground">
              A weekly gathering in Spokane built on real conversations and deeper connection —
              four rotating Friday themes, lunch, and a live podcast hour. Bring a friend.
            </p>
            <div className="mt-4">
              <InstallButton />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
            <div>
              <h4 className="text-sm font-semibold text-foreground">Explore</h4>
              <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
                <li><a href="/#next" className="hover:text-foreground">Next Friday</a></li>
                <li><a href="/#venues" className="hover:text-foreground">Venues</a></li>
                <li><a href="/#topics" className="hover:text-foreground">Topics</a></li>
                <li><a href="/#events" className="hover:text-foreground">Events</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground">Members</h4>
              <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
                <li><Link to="/login" className="hover:text-foreground">Sign in</Link></li>
                <li><Link to="/register" className="hover:text-foreground">Join the group</Link></li>
                <li><Link to="/portal" className="hover:text-foreground">Member portal</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground">Group</h4>
              <ul className="mt-3 space-y-2 text-sm text-muted-foreground">
                <li><Link to="/partner" className="hover:text-foreground">Partner with us</Link></li>
                <li><Link to="/press" className="hover:text-foreground">Press kit</Link></li>
                <li><Link to="/privacy" className="hover:text-foreground">Privacy &amp; transparency</Link></li>
                <li><a href="/#join" className="hover:text-foreground">How it works</a></li>
                <li><a href="/#first-friday" className="hover:text-foreground">Your first Friday</a></li>
              </ul>
            </div>
          </div>
        </div>
        <Separator className="my-8" />
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} Friday Conversations. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
